import React from 'react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import cauzenlogo from '../assest/CauZen Logo 01.png'


const Footer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const scrollToSection1 = (sectionId) => {
        if (location.pathname !== '/') {
            navigate('/', { state: { scrollTo: sectionId } });
        } else {
            const section = document.getElementById(sectionId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };
    return (
        <footer className="cuazen-footer">
            <div className="footer-top">
                <div className="footer-brand">
                    <div className="footer-logo"><img src={cauzenlogo} alt='logo' onClick={() => scrollToSection1("Home")} /><h1>CauZen</h1></div>
                    <div className="social-icons">
                        <a href="https://www.linkedin.com/company/cauzen/ " target="_blank" rel="noopener noreferrer">  <i className="fab fa-linkedin"></i></a>
                        <a href="https://www.youtube.com/@CauzenInc" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                        <a href="https://www.facebook.com/profile.php?id=61576858102341" target="_blank" rel="noopener noreferrer">  <i className="fab fa-facebook"></i></a>
                        <a href="https://x.com/cauzeninc" target="_blank" rel="noopener noreferrer">  <i className="fa-brands fa-x-twitter"></i></a>
                        {/* <a href="#" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-square-instagram"></i></a> */}
                       {/* hiding instagram because account is not ready. instagram need to be unhide once account is ready */}

                    </div>
                </div>

                <div className="footer-links">
                    <div className="footer-column">
                        <h4>COMPANY</h4>
                        <ul>
                            <li onClick={() => scrollToSection1("Home")}>Home</li>
                            <li onClick={() => scrollToSection1("about")}>About</li>
                            <li onClick={() => scrollToSection1("contact")}> Contact</li>
                            <li onClick={() => scrollToSection1("gallery")}>Solution Gallery</li>
                            <li onClick={() => scrollToSection1("solution")}>Solution</li>
                            <li onClick={() => scrollToSection1("Careers")}>Careers</li>

                        </ul>
                    </div>

                    <div className="footer-column">
                        {/* <h4>RESOURCES</h4> */}
                        <ul>
                        </ul>
                    </div>

                    <div className="footer-column">
                        {/* <h4>FEATURES</h4> */}
                        <ul>
                            {/* <li>Task Management</li>
                            <li>Gantt Charts </li>
                            <li>Time Tracking</li>
                            <li>Resource Allocation</li> */}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© 2025 CauZen. All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
